export const stripPhoneNumberFormatting = (phoneNumber: string) => phoneNumber.replace(/\D/g, '');
